import React, { useState } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import {
  Drawer,
  IconButton,
  Grid,
  Divider,
  Typography,
} from "@material-ui/core";
import CreateNewFolderIcon from "@material-ui/icons/CreateNewFolder";
import { IFolder } from "../../core/redux/dataMap/folder";
import { FolderList } from "./FolderList";
import { IArticle } from "../../core/redux/dataMap/article";
// import { SubFolderSidebar } from "./SubFolderSidebar";
// import { ReactComponent as UnionIcon } from "../../assets/imgs/icons/Union.svg";
import MenuIcon from "@material-ui/icons/Menu";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import useLanguage from "../../hooks/useLanguage";

interface IFoldersSidebarProps {
  folders: IFolder[];
  loading: boolean;
  setArticleList(articles: IArticle[]): void;
  selectFolder: React.Dispatch<React.SetStateAction<IFolder>>;
  // selectSubFolder: React.Dispatch<React.SetStateAction<IFolder>>;
  selectedFolder: IFolder;
  // selectedSubFolder: IFolder;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  openDeleteModal(IFolder): void;
  openModal(): void;
  setRootFolder(): void;
  setParentFolder: React.Dispatch<React.SetStateAction<number>>;
}

const defaultFolder: IFolder = {
  id: 0,
  name: "",
  articles: [],
  updatedAt: "",
  createdAt: "",
  subFolder: null,
  parentFolder: null,
};

export const FoldersSidebar: React.FC<IFoldersSidebarProps> = (props) => {
  const {
    selectFolder,
    selectedFolder,

    openModal,
    // selectedSubFolder,
    // selectSubFolder,
    // openDeleteModal,
    // setParentFolder,
  } = props;
  const [open, setOpen] = useState(false);
  const { language } = useLanguage();
  const { translate } = language;
  const classes = useStyles();
  const handleDrawer = () => {
    setOpen(!open);
    selectFolder(defaultFolder);
  };

  return (
    <div className={classes.root}>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <Grid
          container
          direction="column"
          className={classes.content}
          alignItems="center"
        >
          <Grid item className={classes.header}>
            <Grid container alignItems="center" justify="space-around">
              <Grid item md={open ? 4 : 12} className={classes.headerTitle}>
                <IconButton color="primary" onClick={openModal}>
                  <CreateNewFolderIcon />
                </IconButton>
              </Grid>
              <Grid
                item
                md={8}
                className={clsx({
                  [classes.hide]: !open,
                })}
              >
                <Typography variant="h6">{translate.new_folder}</Typography>
              </Grid>
            </Grid>
            <Divider />
            <Grid item className={classes.foldersContainer}>
              <FolderList
                {...props}
                selectFolder={selectFolder}
                selectedFolder={selectedFolder}
              />
            </Grid>
            <Grid
              item
              className={open ? classes.menuButton : classes.headerTitle}
            >
              <IconButton onClick={handleDrawer}>
                {open ? <MenuOpenIcon /> : <MenuIcon />}
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Drawer>
      {/* <SubFolderSidebar
        folders={selectedFolder ? selectedFolder.subFolder : null}
        selectFolder={selectSubFolder}
        selectedFolder={selectedSubFolder}
        openNewFolderModal={openModal}
        openDeleteModal={openDeleteModal}
        setParentFolder={setParentFolder}
      /> */}
    </div>
  );
};

const drawerWidth = 205;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    header: {
      width: "100%",
      marginTop: "10px",
    },
    headerTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    menuButton: {
      justifyContent: "flex-start",
      marginLeft: "12px",
    },
    foldersContainer: {
      marginTop: "30px",
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: "nowrap",
      zIndex: 900,
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      overflowX: "hidden",
      backgroundColor: "#fff",
      boxShadow:
        "2px 0px 2px -5px rgba(0,0,0,0.2), 1px 4px 1px -1px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9) + 1,
      },
      backgroundColor: "#fff",
      borderRight: "none",
      boxShadow:
        "2px 0px 2px -5px rgba(0,0,0,0.2), 1px 4px 1px -1px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    hide: {
      display: "none",
    },
    navItemOpen: {
      justifyContent: "center",
      margin: "4px",
      color: theme.palette.secondary.contrastText,
      "& .active & :hover": {
        color: "rgba(61, 68, 74, 0.8)",
        boxShadow: "0px 0px 7px 0px rgba(0, 0, 0, 0.1)",
      },
      width: "90%",
      " & a": {
        color: theme.palette.secondary.contrastText,
        borderRadius: "5px",
      },
      " & .active": {
        color: theme.palette.primary.main,
        borderRadius: "5px",
      },
    },
    navItem: {
      textAlign: "center",
      justifyContent: "center",
      margin: "4px",
      borderRadius: "5px",
      width: "90%",
      color: theme.palette.secondary.contrastText,
      "& .active & :hover": {
        color: "rgba(61, 68, 74, 0.8)",
        boxShadow: "0px 0px 7px 0px rgba(0, 0, 0, 0.1)",
      },
      " & a": {
        color: theme.palette.secondary.contrastText,
        borderRadius: "5px",
      },
      " & .active": {
        color: theme.palette.primary.main,
        borderRadius: "5px",
      },
    },
    content: {
      marginTop: "60px",
    },
  })
);
